import React from "react";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";


const ParticlesBG = () => {

    const particlesInit = async (main) => {
        // console.log(main);
    
        // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(main);
      };
    
      const particlesLoaded = (container) => {
        // console.log(container);
      };


return (
  <div>
    <Particles
      id="tsparticles"
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
        // background: {
        //   color: {
        //     value: "#0d47a1",
        //   },
        // },
        fullScreen: {
          enable: false
        },
        fpsLimit: 30,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "push",
            },
            onHover: {
              enable: true,
              mode: "attract",
            },
            resize: true,
          },
          modes: {
            push: {
              quantity: 4,
            },
            attract: {
              distance: 200,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value:["#67b7dc", "#6771dc", "#a367dc", "#dc67ce", "#dc6788"],
          },
          links: {
            color: "#000",
            distance: 100,
            enable: true,
            opacity: 0.2,
            width: 1,
          },
          collisions: {
            enable: true,
          },
          move: {
            direction: "none",
            enable: true,
            outModes: {
              default: "bounce",
            },
            random: true,
            speed: 0.3,
            straight: false,
          },
          number: {
            density: {
              enable: true,
              area: 800,
            },
            value: 80,
          },
          opacity: {
            value: 0.5,
          },
          shape: {
            type: "circle",
          },
          size: {
            value: { min: 1, max: 8 },
          },
          life: {
            count: 1,
            duration: 3,
            delay: 0
          },
        },
        detectRetina: true,
        pauseOnBlur: true,
      }}
    />
  </div>
  );
};

export default ParticlesBG;